<template>
    <div class="underlineCourse">
        <div class="dataList" >
            <div class="dataRow marginB8 white_bg" v-for="(dataItem, index) in dataList"
                 :key="dataItem.id" :data-id="dataItem.id" @click="viewItem(dataItem)">
                <div class="flexLayout">
                    <div style="width: 140px; margin-right: 8px;">
                        <div class="imageArea roundBorder8 hiddenOverflow w100p"
                             style="height: 83px;">
                            <img class="fullSpace cover" :src="dataItem.coverImg"
                                 v-if="dataItem.coverImg"/>
                        </div>
                    </div>

                    <div class="flexItem">
                        <div class="lineHeight21r14f bold font14r grey20 hiddenOverflow" style="
                                max-height: 3em;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;">
                            {{dataItem.title}}
                        </div>
                        <div class="font12r gold bold marginT12">主办方：{{dataItem.teacherName}}</div>
                    </div>
                </div>
                <div class="marginT12 flexLayout font12r grey" style="line-height: 1.5em;">
                    <div class="flexItem hiddenOverflow showEllipsisIfOverflow" style="height: 1.5em; padding-right: 24px;">
                        <i class="icon locationIcon" style="margin-right: 2px"></i>
                        {{dataItem.city}} | {{dataItem.address}}
                    </div>
                    <div class="flexItem hiddenOverflow showEllipsisIfOverflow" style="height: 1.5em;">
                        <i class="icon clockIcon" style="margin-right: 2px"></i>
                        {{formatDate(dataItem.startTime)}}&nbsp;&nbsp;&nbsp;&nbsp;{{formatTimeRange(dataItem.startTime, dataItem.endTime)}}
                    </div>
                </div>
                <div class="bold grey20 marginT12 clearfix" style="line-height: 30px;">
                    <div class="fl">
                        <strong class="red" v-if="!dataItem.price">免费</strong>
                        <strong class="red font12r" v-if="dataItem.price">￥</strong>
                        <strong class="red" v-if="dataItem.price">{{dataItem.price}}</strong>
                        <span class="marginL4 darkgrey font12r">/限{{dataItem.maxPlayers}}人</span>
                    </div>
                    <div class="fr grey font14r" style="padding-top: 2px;">
                        <button class="signUpButton font14r white" @click="viewItem(dataItem)">立即报名</button>
                    </div>
                </div>
            </div>

            <div class="alignCenter paddingV8" v-show="status === 'loading'">
                <i class="icon spinner-loader"></i>
            </div>

            <div class="paddingV16 colorCCC font14r alignC"
                 v-show="status == 'ready' && dataList.length < 1">
                暂无任何课程
            </div>

            <div class="paddingV16 colorCCC font14r alignC"
                 v-show="status == 'error'">
                加载数据失败
            </div>

        </div>
    </div>

</template>

<script>
import modulePart from '@comp/part/modulePart';

// style
import './style.scss';

// config
import appConfig from '@/appConfig';

// util
import numberHelper     from "@/util/numberHelper";
import arrayHelper      from "@/util/arrayHelper";
import dataMixedUtils   from "@/util/dataMixedUtils";
import appHelper        from "@/util/appHelper";
import moment from "moment";

const config = {
    apiConfig : {
        list : {
            url : 'portal/underline/v2/course/get/correlation',
            params : {},
            dataPath : 'data',
            dataColumnMapping : {
                // userName : 'name''
            }
        }
    },
    demoTitleList : [
        '园长“苦恼”，幼儿园之间到底在竞争什么',
        '如何使运营的微信公众号活跃起来？',
        '做好这几点，让园区摆脱对名师的依赖'
    ]
};

export default {
    name: "underlineRecommendList",
    extends : modulePart,
    components : {  },
    props : {
        title : {
            type : String,
            default : '模块标题'
        },
        id : String
    },
    data () {
        return {
            apiConfig : config.apiConfig
        }
    },
    methods : {
        viewItem(dataItem) {
            appHelper.goToPage('underlineCourseDetail', {
                id : dataItem.id
            });
        },
        formatTimeRange(startTime, endTime) {
            return moment(startTime).format('HH:mm') + '-' + moment(endTime).format('HH:mm');
        }
    },
    mounted() {

        if (appConfig.mode == 'demo')
        {
            this.dataList = dataMixedUtils.array.buildDataList(8, (index) => {
                return {
                    id : index,
                    title : arrayHelper.getRandomItem(config.demoTitleList),
                    coverImg : appHelper.getRandomCoverImage(),
                    userHead : appHelper.getRandomUserHead(),
                    createTime : new Date().getTime() - numberHelper.getRandomInteger(1000 * 60 * 60 * 24 * 7),
                }
            });
        }
        this.apiConfig.list.params.id = this.id;
        this.reloadDataList();
    }
}
</script>

<style lang="scss" scoped>

</style>
